import { ReactNode } from 'react';
import { useStyles } from '../styles';

interface BaseCardProps {
  children: ReactNode;
  padding?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function BaseCard({
  children,
  padding = 'md',
  className = '',
}: BaseCardProps) {
  const classes = useStyles();
  const paddingMap = {
    sm: 'p-2',
    md: 'p-3',
    lg: 'p-4',
  };

  return (
    <div
      className={`rounded-lg ${paddingMap[padding]} ${classes.baseCardRoot} ${className}`}
    >
      {children}
    </div>
  );
}
